import React, { useState } from "react";
import logoMobile from "../img/redes.jpg";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const Login = ({ onLoginSuccess }) => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(
        "https://optimarketok.com.ar/api/login.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(credentials),
          // --- ESTA LÍNEA ES LA QUE ARREGLA EL ERROR DE CORS Y GUARDA LA SESIÓN ---
          credentials: "include",
        },
      );

      const data = await response.json();

      if (data.success) {
        // Guardamos en sessionStorage para que la sesión expire al cerrar la pestaña
        sessionStorage.setItem("isAdmin", "true");
        onLoginSuccess(true);
      } else {
        Swal.fire(
          "Error",
          data.message || "Email o clave incorrectos",
          "error",
        );
      }
    } catch (error) {
      console.error("Fallo de conexión:", error);
      Swal.fire(
        "Error",
        "No se pudo conectar con el servidor PHP. Revisá el CORS.",
        "error",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container" style={{ marginTop: "100px" }}>
      <div className="row justify-content-center">
        <div className="col-12 col-md-4">
          <div className="text-center mb-4">
            <Link to="/">
              <img src={logoMobile} width="250" alt="logo" />
            </Link>
          </div>
          <div className="card p-4 shadow border-0 rounded-4">
            <h4 className="text-center mb-4 fw-bold">Panel de Control</h4>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label small text-muted">
                  Correo electrónico
                </label>
                <input
                  type="email"
                  name="email"
                  className="form-control form-control-lg"
                  placeholder="admin@ejemplo.com"
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label small text-muted">
                  Contraseña
                </label>
                <input
                  type="password"
                  name="password"
                  className="form-control form-control-lg"
                  placeholder="••••••••"
                  onChange={handleChange}
                  required
                />
              </div>
              <button
                type="submit"
                className="btn btn-dark w-100 py-2 fw-bold mt-2"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    VERIFICANDO...
                  </>
                ) : (
                  "ENTRAR"
                )}
              </button>
            </form>
          </div>
          <div className="text-center mt-4">
            <Link to="/" className="text-decoration-none text-muted small">
              <i className="bi bi-arrow-left me-1"></i> Volver a la tienda
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
